/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './patient-procedure-plan.reducer';

export const PatientProcedurePlanDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const patientProcedurePlanEntity = useAppSelector(state => state.patientProcedurePlan.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="patientProcedurePlanDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.patientProcedurePlan.detail.title">PatientProcedurePlan</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.patientProcedurePlan.id">Id</Translate>
            </span>
          </dt>
          <dd>{patientProcedurePlanEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.patientProcedurePlan.active">Active</Translate>
            </span>
          </dt>
          <dd>{patientProcedurePlanEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.patientProcedurePlan.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{patientProcedurePlanEntity.cursor}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.patientProcedurePlan.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{patientProcedurePlanEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.patientProcedurePlan.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{patientProcedurePlanEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.patientProcedurePlan.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{patientProcedurePlanEntity.timestampentry}</dd>
          <dt>
            <span id="notes">
              <Translate contentKey="tinyMedicRestApp.patientProcedurePlan.notes">Notes</Translate>
            </span>
          </dt>
          <dd>{patientProcedurePlanEntity.notes}</dd>
          <dt>
            <span id="noteType">
              <Translate contentKey="tinyMedicRestApp.patientProcedurePlan.noteType">Note Type</Translate>
            </span>
          </dt>
          <dd>{patientProcedurePlanEntity.noteType}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.patientProcedurePlan.procedure">Procedure</Translate>
          </dt>
          <dd>{patientProcedurePlanEntity.procedure ? patientProcedurePlanEntity.procedure.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.patientProcedurePlan.recordedBy">Recorded By</Translate>
          </dt>
          <dd>{patientProcedurePlanEntity.recordedBy ? patientProcedurePlanEntity.recordedBy.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.patientProcedurePlan.referral">Referral</Translate>
          </dt>
          <dd>{patientProcedurePlanEntity.referral ? patientProcedurePlanEntity.referral.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/patient-procedure-plan" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/patient-procedure-plan/${patientProcedurePlanEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PatientProcedurePlanDetail;
